var React = require('react');

function IconsDoor (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Door Icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M18 148h81V12H18z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M18.6 146.4h78.8V12.6H18.6zM17 148h82V11H17z","key":1}),React.createElement("path",{"fill":"currentColor","d":"M32.65 78.39h19.7V24.6h-19.7zM31 80h23V23H31zM64.65 78.39h19.7V24.6h-19.7zM63 80h23V23H63zM31.61 135.39H85.4V95.61H31.6zM30 137h57V94H30zM95 87a4 4 0 1 1-8 0 4 4 0 0 1 8 0","key":2}),React.createElement("path",{"fill":"currentColor","d":"M57.92 0v1.62h51.31v147.76h-3.95V5.56H57.92v1.62h45.75V151h7.18V0zM5 0v152h7.18V7.18h45.74V5.56H10.56v144.82H6.62V1.62h51.3V0z","key":3}),React.createElement("path",{"fill":"currentColor","d":"M0 150h116v2H0z","key":4})])]);
}

IconsDoor.defaultProps = {"viewBox":"0 0 116 152"};

module.exports = IconsDoor;

IconsDoor.default = IconsDoor;
